import { Link } from "react-router-dom";
import { Container, PageTitle, NbCard } from "@/components/nb";
import { Stagger, Item } from "@/components/motion";
import { Rocket, Lightbulb, Trophy, Compass, ArrowRight } from "lucide-react";

const items = [
  { to: "/ideas/submit", title: "Submit an Idea", desc: "Drop it. Get a 6-step roadmap from AI.", icon: Rocket, color: "primary", tid: "ideas-submit" },
  { to: "/ideas/explore", title: "Explore by Interest", desc: "Tech, social impact, sustainability, more.", icon: Compass, color: "secondary", tid: "ideas-explore" },
  { to: "/ideas/challenge", title: "Monthly Challenge", desc: "New prompt every month. Community votes.", icon: Trophy, color: "tertiary", tid: "ideas-challenge" },
];

export default function EntreHub() {
  return (
    <Container>
      <PageTitle eyebrow="ENTREPRENEURSHIP" title="Ideas → prototypes → real things." sub="Not next year. Not after college. Now." />
      <Stagger className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {items.map((i) => {
          const Icon = i.icon;
          return (
            <Item key={i.to}>
              <Link to={i.to} data-testid={i.tid} className="block h-full">
                <NbCard color={i.color} className="h-full min-h-[220px] flex flex-col justify-between nb-hover-lg">
                  <div className="flex justify-between"><Icon className="w-8 h-8" /><ArrowRight className="w-6 h-6" /></div>
                  <div>
                    <h3 className="font-heading font-black text-2xl tracking-tighter">{i.title}</h3>
                    <p className="mt-2 text-neutral-800">{i.desc}</p>
                  </div>
                </NbCard>
              </Link>
            </Item>
          );
        })}
      </Stagger>
    </Container>
  );
}
